module.exports = __webpack_public_path__ + "static/img/014.25a1dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-head/014.png
// module id = ojeJ
// module chunks = 1